export default "__VITE_ASSET__BzHocrP1__"